import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import * as User from "./reducers/userReducer";
import * as Client from "./reducers/clientFormReducer";


const rootReducer = combineReducers({
  // user reducers
  userLogin: User.userLoginReducer,
  clientForm: Client.addClientFormReducer
  // client form reducers
});

// get zivaInteriorsUserInfoFromStorage from  localStorage
const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

// initialState
const initialState = {
  userLogin: { userInfo: userInfoFromStorage },
};
const persistConfig = {
  key: "root",
  storage: storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  preloadedState: initialState,
  devTools:
    process.env.NODE_ENV !== "production" &&
    typeof window.__REDUX_DEVTOOLS_EXTENSION__ === "undefined"
      ? (a) => a
      : window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__(),
  middleware: [thunk],
});

export const persistor = persistStore(store);
